import { Button, Table } from '@insight-health-ai/roseate/components';

import { useMagicFlowContext } from '../MagicFlowContext';

export const FlowsTab = () => {
  const {
    hasOrgSelected,
    openCreateFlow,
    flowTableData,
    flowColumns,
    isLoadingFlows,
    isFetchingFlows,
  } = useMagicFlowContext();

  return (
    <div className="space-y-4">
      <div className="flex justify-end">
        <Button
          appearance="primary"
          onClick={openCreateFlow}
          disabled={!hasOrgSelected}
        >
          Create Flow
        </Button>
      </div>
      <div className="rounded-xl shadow-xl bg-white">
        <Table
          data={flowTableData}
          columns={flowColumns}
          rowKey="key"
          loading={isLoadingFlows || isFetchingFlows}
          pagination={{
            defaultPageSize: 10,
            showSizeChanger: true,
            pageSizeOptions: ['10', '20', '50'],
          }}
          emptyText={hasOrgSelected ? 'No flows' : 'Select an organization'}
        />
      </div>
    </div>
  );
};
